module.exports = __webpack_public_path__ + "static/img/sharetip.eb065c9c.png";